module.exports = __webpack_public_path__ + "img/group.9414a015.svg";